export const MONTHLY = 'Monthly'
export const YEARLY = 'Yearly'
export const QUARTERLY = 'Quarterly'
export const DEFAULT_INVOICE_VOLUME = 1000000
export const INVOICE_INCREMENTAL_VOLUME = 1000000
export const FREE_PACKAGE_INVOICE_VOLUME = 10000
export const INTEGRATIONS = 'Integrations'
export const INTEGRATION = 'Integration'
